/**
 * 화면에 보이는 헤더의 하단 위치(px) = 배너 + GNB.
 *
 * 헤더는 항상 화면 맨 위에 붙어 있어 GNB 의 헤더 기준 위치(offsetTop + offsetHeight)가 곧
 * 화면상 하단이다. `header.offsetHeight` 는 헤더 박스 구조(배너·GNB 배치)에 따라 의미가
 * 달라지므로 쓰지 않는다. getBoundingClientRect 를 쓰지 않는 이유: 메인 GNB drop-in
 * 애니메이션(transform) 도중에 재면 이동 중 위치가 잡힌다. 메가메뉴가 펼쳐져 있으면 그 높이도
 * 포함된다.
 */
export function getVisibleHeaderBottom(): number {
  const gnb = document.querySelector<HTMLElement>('header [data-header-gnb]');
  return gnb ? gnb.offsetTop + gnb.offsetHeight : 0;
}
